module.exports = __webpack_public_path__ + "static/media/starRate.3aa0d723.png";